import React, { FC } from 'react';
import type { AttachFileProps } from '~/src/components/common-components/attach-file/attach-file.types';
import { SvgClose } from '~/src/components/svg-components/close';
import * as Styled from './attach-file.styles';

export const AttachFile: FC<AttachFileProps> = ({
    ImageComponent,
    fileName,
    fileSize,
    textError,
    isLoading = false,
    onCloseClick,
    progress,
    unitsText = 'MB',
}) => {

    return (
        <Styled.AttachFileContainer data-testid={'attach-container'}>
            <Styled.BodyContainer>
                {!textError && ImageComponent && <Styled.ImageWrapper data-testid={'attach-img'}>
                    <ImageComponent/>
                </Styled.ImageWrapper>}
                <Styled.BodyWrapper>
                    <Styled.FileName>{fileName}</Styled.FileName>
                    {isLoading
                        ? <Styled.LoadingBar data-testid={'attach-bar'} progress={progress || 0}/>
                        : <Styled.FileSize data-testid={'attach-size'} hasError={!!textError}>
                            {textError || `${fileSize} ${unitsText}`}
                        </Styled.FileSize>
                    }
                </Styled.BodyWrapper>
            </Styled.BodyContainer>
            <Styled.CrossContainer>
                <Styled.CrossWrapper onClick={onCloseClick} data-testid={'attach-cross'}>
                    <SvgClose/>
                </Styled.CrossWrapper>
            </Styled.CrossContainer>
        </Styled.AttachFileContainer>
    );
};